import { axios } from '@/services/axios';

export const updateCarrier = (carrierData) => {
    return axios.put('/carrier/', carrierData);
};
